import { Component, Inject, NgZone, OnInit, Renderer2 } from "@angular/core";
import { App } from "@capacitor/app";
import { Device, DeviceInfo } from "@capacitor/device";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { SplashScreen } from "@capacitor/splash-screen";
import { AlertController, ModalController, NavController, Platform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription, firstValueFrom } from "rxjs";
import { AuthenticationService } from "./services/authentication/authentication.service";
import { HomeService } from "./services/home-service/home.service";
// const { StatusBar } = Plugins;
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { LegalComponent } from "src/app/components/legal/legal.component";
import { appConfig } from "src/environments/environment";
import { UserModel } from "./models/user.model";
import { DataService } from "./services/data/data.service";
import { NotificationService } from "./services/notification/notification.service";
import { UtilsService } from "./services/utils/utils.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"]
})
export class AppComponent implements OnInit {
  isAuthenticated = false;
  role: string;
  currentMenu:string[] = ['account'];
  onMobileApp: boolean;
  deviceInfo: DeviceInfo;
  appStoreLink: string;
  subscriptionStateChange: Subscription;
  user: UserModel = {};
  version: string;
  context:any;
  languages = ['fr','en'];
  betaLanguages = [];
  @Inject(DOCUMENT) private _document: Document

  constructor(
    private translateService: TranslateService,
    public alertCtrl: AlertController,
    private platform: Platform,
    private auth: AuthenticationService,
    private homeService: HomeService,
    private dataService: DataService,
    public nav: NavController,
    private zone: NgZone,
    private modalCtrl: ModalController,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private _renderer2: Renderer2,
    private utils: UtilsService
  ) {
    // const app = initializeApp(firebaseConfig);
    // if (Capacitor.isNativePlatform) {
    //   initializeAuth(app, {
    //     persistence: indexedDBLocalPersistence
    //   });
    // }
    this.initApp();
  }

  ngOnInit() {
    this.setupDeeplink();
  }

  async initApp() {
    SplashScreen.hide();
    await this.checkLanguage();
    await this.platform.ready();
    // console.log('platform ready');
    await this.checkVersion();
    await this.createCacheFolder();
    //this.notificationService.checkNotificationToken(val);
    this.setupUserAuthenticationChangeDetection();
    this.openMenu();

  }

  setUpJimo(){
    // if (window.jimo != null) {
    //   return;
    // }
    // window.jimo = [];
    
    // const script = this._renderer2.createElement('script');

    // window['JIMO_PROJECT_ID'] = "e60914d7-1c20-48ba-864c-f1a915f36824";
    // script.type = 'application/ld+json';
    // script.type = 'text/javascript';
    // script.async = true;
    // script.src = "https://undercity.usejimo.com/jimo-invader.js";
    // this._renderer2.appendChild(this._document.body, script);
  }

  async checkLanguage(){
    const language = (await Device.getLanguageCode()).value;
    const newLanguage = this.languages.includes(language) ? language : 'fr'
    this.changeLanguage(newLanguage);
  }

  async changeLanguage(language){
    await firstValueFrom(this.translateService.use(language));
    if(this.betaLanguages.includes(language)){
      console.log(this.translateService.instant('alerts.BetaLanguage'));
      await this.utils.presentToast(this.translateService.instant('alerts.BetaLanguage'))
    }
  }

  async createCacheFolder(){
    // console.log('check cache folder');
    return Filesystem.readdir({
      directory:Directory.Cache,
      path:`CACHED-IMG`
    })
    .then((result) => {
      // console.log('existing cache folder');
      Promise.resolve();
    })
    .catch((error) => {
      // console.log('directory',error);
      return Filesystem.mkdir({
        directory:Directory.Cache,
        path:`CACHED-IMG`
      }).then((result) => {
        // console.log('directory created', result);
        Promise.resolve();
      }).catch((error)=>{
        // console.log('directory error',error);
        Promise.resolve();
      })
    });
    // if(){
    //   console.log('cache folder created');
    //        
    // }

  }

  openMenu(){
    this.route.params.subscribe(params => {
      // console.log('profile param', params.profileId);
    });
  }

  async setupUserAuthenticationChangeDetection() {
    const authService = this.auth.authState$;
    this.subscriptionStateChange = authService.subscribe(async val => {
      // console.log('setupUserAuthenticationChangeDetection',val);
      if (val) {
        await this.notificationService.checkNotificationToken(val);
        this.role = (await this.auth.getUser()).role;
        this.isAuthenticated = true;
        this.user = val;
        this.currentMenu = ['user'];
      } else {
        // this.user = {
        //   displayName: "Invité"
        // };
        // console.log(this.isAuthenticated);
      }
    });
  }

  setupDeeplink(): void {
    // route to deeplink if provided
    App.addListener("appUrlOpen", (data: any) => {
      this.zone.run(() => {
        const slug = data.url.split(".com").pop();
        // console.log(slug)
        if (slug) {
          this.nav.navigateForward(slug);
        }
      });
    });
  }


  async checkVersion(): Promise<void> {
    this.deviceInfo = await Device.getInfo();
    this.onMobileApp = this.deviceInfo.platform == "ios" || this.deviceInfo.platform == "android";
    if(this.onMobileApp){
      const appInfo = await App.getInfo();
      this.version = appInfo.version
    }
    else{
      this.version = appConfig.version
    }
    this.dataService.platform = this.deviceInfo.platform;
    // this.context = await this.utils.getAppInfo(); Using the utils was giving an error
    const appService = this.dataService.getAppVersion(this.deviceInfo.platform);
    appService.subscribe(async val => {
      const lastVersionArray = val.version.split(".").map(version => parseInt(version));
      const currentVersionArray = this.version.split(".").map(version => parseInt(version));      
      if (currentVersionArray[0] < lastVersionArray[0]
          || (currentVersionArray[0] == lastVersionArray[0] && currentVersionArray[1] < lastVersionArray[1]) 
          || (currentVersionArray[0] == lastVersionArray[0] && currentVersionArray[1] == lastVersionArray[1] && currentVersionArray[2] < lastVersionArray[2])) {
        const message = this.translateService.instant("app.OutDated." + this.deviceInfo.platform);

        // Mise à jour obligatoire : l'alerte est infermable et se ré-affiche
        // tant que la version installée est périmée, ce qui empêche tout
        // accès à l'app (et donc toute écriture) jusqu'à la mise à jour.
        let blocked = true;
        while (blocked) {
          const alert = await this.alertCtrl.create({
            header: this.translateService.instant("app.Version") + " " + val.version + " " + this.translateService.instant("app.available"),
            cssClass: "alertMsg",
            message: message,
            backdropDismiss: false,
            buttons: [{ role: "ok", text: this.translateService.instant("app.ToUpdate") }]
          });
          await alert.present();
          await alert.onDidDismiss();
          if (this.onMobileApp) {
            this.openMarketPlace();
          } else {
            window.location.reload();
            blocked = false;
          }
        }
      }
    });
  }

  async showLegal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: LegalComponent,
      cssClass: "modal"
    });
    return await modal.present();
    //window.open("https://latourneedesproducteurs.com/legal", "_blank");
  }
  showFacebook(): void {
    window.open("https://www.facebook.com/latourneedesproducteurs", "_blank");
  }
  showMessenger(): void {
    window.open("https://www.facebook.com/latourneedesproducteurs", "_blank");
  }
  showAboutUs(): void {
    window.open("https://www.latourneedesproducteurs.com/aboutus", "_blank");
  }
  showUserGuide(): void {
    window.open(this.translateService.instant('userGuide.links.home'), "_blank");
  }
  showInstagram(): void {
    //Browser.open({url:''});
    window.open("https://www.instagram.com/latourneedesproducteurs", "_blank");
  }
  showEmail(): void {
    //Browser.open({url:''});
    window.open("mailto:info@latourneedesproducteurs.com", "_self");
  }
  showInfo(): void {
    window.open("https://latourneedesproducteurs.com", "_blank");
  }

  viewProfile(): void {
    this.homeService.viewProfile();
  }

  openMarketPlace(): void {
    if (this.deviceInfo && this.deviceInfo.platform === "ios") {
      window.open("itms-apps://apps.apple.com/app/id1511406664", "_system");
    } else {
      window.open("market://details?id=com.latourneedesproducteurs", "_system");
    }
  }

  makeDonation(): void {
    window.open("https://www.helloasso.com/associations/et-si-nous-mangions-autrement/formulaires/1", "_blank");
  }
}
